import createReactComponent from '../createReactComponent';
export default createReactComponent('mood-sick', 'IconMoodSick', [
  ['path', { d: 'M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z', key: 'svg-0' }],
  ['path', { d: 'M9 10h-.01', key: 'svg-1' }],
  ['path', { d: 'M15 10h-.01', key: 'svg-2' }],
  ['path', { d: 'M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1', key: 'svg-3' }],
]);
